import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { RootState } from '../../store';
import { getFirstAccessibleModulePath } from '../../config/moduleRegistry';

interface ModuleRouteProps {
  children: React.ReactNode;
  moduleKey: string;
  // Optional list of roles allowed to access; if provided, user must have one of these roles too
  roles?: string[];
}

const ModuleRoute: React.FC<ModuleRouteProps> = ({ children, moduleKey, roles: _roles }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const allowedModules: string[] = ((user as any)?.allowedmodules ?? []) as string[];
  const hasModule = allowedModules.includes(moduleKey);

  if (!hasModule) {
    const fallbackPath = getFirstAccessibleModulePath(allowedModules);
    if (fallbackPath && fallbackPath !== window.location.pathname) {
      return <Navigate to={fallbackPath} replace />;
    }
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
        <Typography variant="h6" color="text.secondary">
          No module access assigned for this page.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ModuleRoute;
